import { eCurativeGradeType } from './eCurativeGradeType';

export interface ISummaryResponse {
  apn?: string | null;
  bankruptcies?: number | null;
  curative_grade?: eCurativeGradeType;
  effective_date?: string | null;
  hoa?: string | null;
  judgements?: number | null;
  open_mortgages?: number | null;
  other_liens?: number | null;
  property_tax_summary?: string;
  texas_evidence_fee?: number | null;
  texas_evidence_percent?: number | null;
  texas_evidence_agent?: string | null;
}

export interface ISummaryData {
  apn?: string | null;
  bankruptcies?: number | null;
  curativeGrade?: eCurativeGradeType;
  effectiveDate?: string | null;
  hoa?: string | null;
  judgements?: number | null;
  openMortgages?: number | null;
  otherLiens?: number | null;
  propertyTaxSummary?: string;
  titleEvidenceFee?: number | null;
  titleEvidenceAgent?: string | null;
  titleEvidencePercent?: number | null;
}

export const createDefaultSummaryData = (): ISummaryData => ({});

export const convertSummaryResponseToSummaryData = (res: ISummaryResponse): ISummaryData => ({
  apn: res.apn,
  bankruptcies: res.bankruptcies,
  curativeGrade: res.curative_grade,
  effectiveDate: res.effective_date,
  hoa: res.hoa,
  judgements: res.judgements,
  openMortgages: res.open_mortgages,
  otherLiens: res.other_liens,
  propertyTaxSummary: res.property_tax_summary,
  titleEvidenceAgent: res.texas_evidence_agent,
  titleEvidenceFee: res.texas_evidence_fee,
  titleEvidencePercent: res.texas_evidence_percent,
});

export const convertSummaryDataToSummaryResponse = (data: ISummaryData): ISummaryResponse => ({
  apn: data.apn,
  bankruptcies: data.bankruptcies,
  curative_grade: data.curativeGrade,
  effective_date: data.effectiveDate,
  hoa: data.hoa,
  judgements: data.judgements,
  open_mortgages: data.openMortgages,
  other_liens: data.otherLiens,
  property_tax_summary: data.propertyTaxSummary,
  texas_evidence_percent: data.titleEvidencePercent,
  texas_evidence_fee: data.titleEvidenceFee,
  texas_evidence_agent: data.titleEvidenceAgent,
});
